"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.remove = exports.load = exports.save = void 0;
function save(key, value) {
    localStorage.setItem(key, value);
}
exports.save = save;
function load(key) {
    return localStorage.getItem(key);
}
exports.load = load;
function remove(key) {
    localStorage.removeItem(key);
}
exports.remove = remove;
function clear() {
    localStorage.clear();
}
exports.clear = clear;
